module.exports = __webpack_public_path__ + "img/01.a0cc01b4.jpg";